module.exports = __webpack_public_path__ + "static/media/sue.8377cbea.jpg";